import firebase from 'firebase/compat/app';

import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/analytics';
import 'firebase/compat/functions';

const firebaseConfig = {
	apiKey: 'AIzaSyA6_9hAqkQEkIsZ1cuzRbGXyj5e1HCYAYY',
	authDomain: 'premios-sadosky.firebaseapp.com',
	databaseURL: 'https://premios-sadosky.firebaseio.com',
	projectId: 'premios-sadosky',
	storageBucket: 'premios-sadosky.appspot.com',
	messagingSenderId: '283236588611',
	appId: '1:283236588611:web:2f5a6702db2cf753bdc8f6',
	measurementId: 'G-0H9QCE0S9M'
};

export const firebaseApp = firebase.apps.length ? firebase.apps[0] : firebase.initializeApp(firebaseConfig);

export const firebaseDB = firebase.firestore();

export const firebaseStorage = firebase.storage();

export const cloudFunctions = firebase.functions();

export const getDateTimeNow = () => {
	return firebase.firestore.Timestamp.fromDate(new Date());
}

// Conexión a Firebase Emulators: opt-in explícito.
// Por default `npm start` apunta a Firebase productivo.
// Para usar emuladores: VITE_USE_FIREBASE_EMULATORS=true npm start
const shouldUseEmulators =
	import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true';

if (shouldUseEmulators) {
	firebase.auth().useEmulator('http://localhost:9099');
	firebaseDB.useEmulator('localhost', 8080);
	firebaseStorage.useEmulator('localhost', 9199);
	cloudFunctions.useEmulator('localhost', 5001);
	// eslint-disable-next-line no-console
	console.info('[firebase] Conectado a emuladores locales');
}

// Analytics requiere el SDK real, no funciona contra emuladores.
if (!shouldUseEmulators) {
	firebase.analytics();
}
